angular.module("vgresiduos").controller("editContactCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton(
				$rootScope,
				`organizacao/fornecedores/${$stateParams.supplierCode}/contato/${$stateParams.contactId}`,
				[{ key: "supplierId", value: $stateParams.supplierId }]
			);
		};
	}
]);
